import classNames from 'classnames';
import { BaseFieldProps, FieldType } from './Field';
import Tooltip, { TooltipPlacement } from '../tooltip/tooltip';
import Icon, { IconType } from '../icon/Icon';

export interface FieldLabelProps extends BaseFieldProps {
  fieldType: FieldType;
  label: string;
  labelSmall?: boolean;
  tabIndex?: number;
  tooltip?: string;
  required?: boolean;
  hideLabel?: boolean;
  amount?: string;
}

const FieldLabel = ({
  fieldType,
  label,
  labelSmall = false,
  tabIndex,
  tooltip,
  required,
  hideLabel = false,
  amount,
  ...props
}: FieldLabelProps) => {
  return (
    <label
      htmlFor={props.id}
      tabIndex={tabIndex}
      className={classNames({
        'o-flex': tooltip,
        'u-text-small':
          labelSmall &&
          fieldType !== FieldType.CHECKBOX &&
          fieldType !== FieldType.RADIO,
        'u-label':
          !labelSmall &&
          fieldType !== FieldType.CHECKBOX &&
          fieldType !== FieldType.RADIO,
        hide:
          hideLabel &&
          (fieldType === FieldType.CHECKBOX || fieldType === FieldType.RADIO),
        'u-sr':
          hideLabel &&
          fieldType !== FieldType.CHECKBOX &&
          fieldType !== FieldType.RADIO,
      })}
    >
      {required && '*'}
      <span className="a-form-field__label">
        {label}
        {typeof amount === 'string' && ` (${amount})`}
      </span>
      {tooltip && (
        <Tooltip
          content={tooltip}
          placement={TooltipPlacement.TOP}
          children={<Icon iconType={IconType.Info} className="u-icon-small" />}
        ></Tooltip>
      )}
    </label>
  );
};

export default FieldLabel;
